import React from 'react';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';
import UserFilled from 'assets/svgs/common/user-filled.svg';
import Star from 'assets/svgs/common/star-white.svg';
import Wifi from 'assets/svgs/common/wifi.svg';
import Publlish from 'assets/svgs/status/published-white.svg';
import moment from 'moment';

const basicUserSelector = makeSelectBasicUser();
const ReaderInformation = () => {
  const userDetails = useSelector(basicUserSelector);

  return (
    <div className="box-dashboard d-flex position-relative  justify-content-center bg-white mb-4">
      <div className="d-flex w-100 align-items-center justify-content-center">
        <div className="user-box d-flex mr-4 pr-3">
          <div className="icon-container d-flex align-items-center justify-content-center mr-3">
            <img src={UserFilled} alt="" />
          </div>
          <div className="d-flex flex-column">
            <span className="reader-inform-heading">Registered From</span>
            <span className="big-text">
              {moment(userDetails.registrationDate).format('YYYY')}
            </span>
          </div>
        </div>
        <div className="user-box d-flex mr-4 pr-3">
          <div className="icon-container d-flex align-items-center justify-content-center mr-3">
            <img src={Wifi} alt="" />
          </div>
          <div className="d-flex flex-column">
            <span className="reader-inform-heading">Login Hours</span>
            <span className="big-text">24</span>
          </div>
        </div>
        <div className="user-box d-flex mr-4 pr-3">
          <div className="icon-container d-flex align-items-center justify-content-center mr-3">
            <img height={20} src={Publlish} alt="" />
          </div>
          <div className="d-flex flex-column">
            <span className="reader-inform-heading">Visited Post</span>
            <span className="big-text">{userDetails.visitedPosts}</span>
          </div>
        </div>
        <div className="user-box d-flex">
          <div className="icon-container d-flex align-items-center justify-content-center mr-3">
            <img src={Star} alt="" />
          </div>
          <div className="d-flex flex-column">
            <span className="reader-inform-heading">Favorite Post</span>
            <span className="big-text">{userDetails.readerPosts}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReaderInformation;
